import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { API, authFetch } from "@/App";

const LEVELS = [
  { min: 80, label: "Conforme", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { min: 60, label: "À vérifier", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { min: 0, label: "Différent", cls: "bg-red-50 text-red-700 border-red-200" },
];

// Colour similarity between the library photo and the email photo (computed server-side).
export function ConformityBadge({ swatch, src, testId }) {
  const [result, setResult] = useState(null);
  const [state, setState] = useState("idle");

  useEffect(() => {
    if (!swatch || !src) return;
    let active = true;
    setState("loading");
    authFetch(`${API}/fabric-swatches/compare`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ swatch_id: swatch.swatch_id, source: src }),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => { if (active) { setResult(d); setState("done"); } })
      .catch(() => active && setState("error"));
    return () => { active = false; };
  }, [swatch, src]);

  if (!swatch) return null;
  if (state === "loading") return <span className="inline-flex items-center gap-1 text-xs text-zinc-500" data-testid={testId}><Loader2 className="w-3 h-3 animate-spin" />Comparaison…</span>;
  if (state === "error") return <span className="text-xs text-zinc-400" data-testid={testId}>Comparaison impossible</span>;
  if (!result) return null;
  const level = LEVELS.find((l) => result.similarity >= l.min);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-xs font-semibold ${level.cls}`} data-testid={testId} title={`Écart de couleur ΔE = ${result.delta_e}`}>
      {level.label} · {result.similarity} %
    </span>
  );
}
